module.exports = __webpack_public_path__ + "img/avatar.064bdd9a.png";